import './IconDDAPause.css';
import React from 'react';
const IconDDAPause = _ref => {
  let {
    width = 48,
    height = 48,
    className = ''
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: `${className} ${styles}`,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 38H20V10H12V38ZM28 10V38H36V10H28Z"
  }));
};
const styles = "sigyamx";
export default IconDDAPause;